/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
import DividerWithText from "../../../../../../../components/DividerWithText";
import SummaryDetailsAttendanceGeofence from "./SummaryDetailsAttendanceGeofence";
import CustomDaySelector from "../../../../../../../components/CustomDaySelector";
import RowResumeText from "../../../../../../../components/RowResumeText";
import GeofencesMap from "../../../../../Traffic/Manage/SubComponents/GeofencesMap";
import {DATE_TIME_FORMAT_NAME_MODEL, getDateFormat} from "../../../../../../../Apis/functions";

const GeofenceSummary = ({ item, dayArray, t, geofences, center }) => {
    return (
        <div className='row mb-5'>
            <DividerWithText title={t('details')} />
            <div className='d-flex justify-content-center'>
                <SummaryDetailsAttendanceGeofence item={item}/>
            </div>
            <DividerWithText title={t('active_schedule')} />
            <div className='d-flex justify-content-center'>
                <div className='row d-flex justify-content-center'>
                    <div className='col-12 p-0'>
                        <div className='mb-4'>
                            <CustomDaySelector dayArray={dayArray} setDayArray={() => {}} readonly={true} />
                        </div>
                    </div>
                    <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6 p-0'>
                        <RowResumeText title={t('from')} value={getDateFormat(item?.opening, null, DATE_TIME_FORMAT_NAME_MODEL.HHmm)} className='mb-4' />
                    </div>
                    <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6 p-0'>
                        <RowResumeText title={t('to')} value={getDateFormat(item?.closing, null, DATE_TIME_FORMAT_NAME_MODEL.HHmm)} className='mb-4' />
                    </div>
                </div>
            </div>
            <DividerWithText title={t('geofence_area')} />
            <div className='d-flex justify-content-center'>
                <div className='col-8 mt-4'>
                    <GeofencesMap
                        center={center}
                        geofences={geofences}
                        geofenceTitle='defined_areas'
                        showTitle={false}
                        classNameMap={"h-500px"}
                    />
                </div>
            </div>
        </div>
    );
};

export default GeofenceSummary;
